<div class="wo-table-filters">
  <div class="wo-table-filters-list tw-w-full">
    <div class="wo-table-filters-list-filters">
      <ng-content select="[woTableFilter]"/>
      <div class="tw-flex tw-gap-[8px] tw-justify-between tw-flex-grow">
        <div class="tw-flex tw-gap-[8px] tw-items-center">
          <button
            tuiButton
            size="s"
            (click)="apply.emit()"
            [showLoader]="state === 'applying'"
            [disabled]="state === 'restoring'"
            data-e2e="filter search button"
          >
            Filter
          </button>
          <button
            class="wo-table-filters__reset"
            appearance="secondary"
            icon="tuiIconRotateCcw"
            tuiIconButton
            type="button"
            size="s"
            (click)="restore.emit()"
            [showLoader]="state === 'restoring'"
            [disabled]="state === 'applying'"
            data-e2e="filter reset button"
          ></button>
        </div>
        <div>
          <ng-content/>
        </div>
      </div>
    </div>
  </div>
</div>
